import {
  UserControllerApiFactory,
  UserCreate,
  UserRole,
  UserSetLoginTwoFactorMode,
  UserSetRoles,
  UserSetStatus,
  UserStatus,
  UserUpdate,
} from 'api';
import { BASE_PATH } from '../config';

export const getCurrentUser = () =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .currentUser()
    .then(res => res.data);

export const getUser = (userId: number) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .getUserInfoWithLzPzus(userId)
    .then(res => res.data);

export const getUsers = ({
  page,
  fioLike,
  statuses,
  lzIds,
  roles,
  sort,
  size,
}: {
  page: number;
  fioLike?: string | undefined;
  statuses?: UserStatus[] | undefined;
  lzIds?: number[] | undefined;
  roles?: UserRole[] | undefined;
  sort?: string[] | undefined;
  size?: number;
}) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .getUserInfoWithLzPage(page, fioLike, statuses, lzIds, roles, sort, size)
    .then(res => res.data);

export const getUsersV2 = ({
  page,
  fioLike,
  statuses,
  lzIds,
  roles,
  sort,
  size,
}: {
  page: number;
  fioLike?: string | undefined;
  statuses?: UserStatus[] | undefined;
  lzIds?: number[] | undefined;
  roles?: UserRole[] | undefined;
  sort?: string[] | undefined;
  size?: number;
}) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .getUserInfoWithLzPageV2(page, fioLike, statuses, lzIds, roles, sort, size)
    .then(res => res.data);

export const createUser = ({ data, smsCode }: { data: UserCreate; smsCode?: string }) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .createUser(data, smsCode)
    .then(res => res.data);

export const setUserStatus = ({ userId, status }: { userId: number; status: UserSetStatus }) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .setStatus(userId, status)
    .then(res => res.data);

export const setUserAvatarId = ({ userId, avatarId }: { userId: number; avatarId: number }) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .setAvatarId(userId, avatarId)
    .then(res => res.data);

export const reactivate = (userId: number) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .reactivateUser(userId)
    .then(res => res.data);

export const updateUserData = ({ userId, userUpdate }: { userId: number; userUpdate: UserUpdate }) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .updateUser(userId, userUpdate)
    .then(res => res.data);

export const setUserRole = ({ userId, userSetRole }: { userId: number; userSetRole: UserSetRoles }) =>
  UserControllerApiFactory(undefined, BASE_PATH).setRoles(userId, userSetRole);

export const getPzuAllowUsers = ({ lzId }: { lzId: number }) =>
  UserControllerApiFactory(undefined, BASE_PATH)
    .getPzuAllowedUsers(lzId)
    .then(res => res.data);

export const setLogin2fa = ({ userId, twoFactorMode }: { userId: number; twoFactorMode: UserSetLoginTwoFactorMode }) =>
  UserControllerApiFactory(undefined, BASE_PATH).setLogin2fa(userId, twoFactorMode);
